import { render, staticRenderFns } from "./SongEditor.vue?vue&type=template&id=5ac69902&"
import script from "./SongEditor.vue?vue&type=script&lang=js&"
export * from "./SongEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SongEditor.vue"
export default component.exports